import { IconTitle1, IconTitle2, IconTitle3 } from '@xingternal/icons';
import {
  HEADING_DEFINITIONS,
  isBlockActive,
  toggleBlock,
} from '@xingternal/content-editor-plugin-helpers';

import { H2, H3, H4 } from './constants';

const iconForLevel = {
  [H2]: IconTitle1,
  [H3]: IconTitle2,
  [H4]: IconTitle3,
};

const buttonConfig = ({
  level = H2,
  disabledForBlockTypes = [],
  ...props
} = {}) => ({
  isHighlighted: (editor) =>
    isBlockActive(editor, HEADING_DEFINITIONS.type, { level }),
  isDisabled: (editor) =>
    disabledForBlockTypes.some((element) => isBlockActive(editor, element)),
  icon: iconForLevel[level],
  label: `H${level}`,
  onClick: (event, editor) => {
    event.preventDefault();
    toggleBlock(editor, HEADING_DEFINITIONS.type, { level });
  },
  ...props,
});

export { buttonConfig };
